import jsonApi from "./jsonApi";
import {invalidateQueries, q} from "../state";
import {AccountFeature, AiModelConfig, PromptModifiers} from "../Types.ts";
import {CURRENT_REGION} from "../utils/region";

export async function changeName(name: string) {
  const res = await jsonApi.post<"ok">(`/region/${CURRENT_REGION}/api/config/account_name`, name);
  await invalidateQueries([q.whoAmIOnAccount.filter(), q.accounts.filter()]);
  return res;
}

export async function updateLanguageCode(languageCode: string) {
  const res = await jsonApi.post<"ok">(`/region/${CURRENT_REGION}/api/config/language_code`, languageCode);
  await invalidateQueries([q.whoAmIOnAccount.filter(), q.accounts.filter()]);
  return res;
}

export async function updatePlanFeature(feature: AccountFeature, active: boolean) {
  const res = await jsonApi.post<"ok">(`/region/${CURRENT_REGION}/api/config/plan_features/${feature}`, active);
  await invalidateQueries([q.whoAmIOnAccount.filter(), q.accounts.filter()]);
  return res;
}

export async function updateEnabledFeature(feature: AccountFeature, enabled: boolean) {
  const res = await jsonApi.post<"ok">(`/region/${CURRENT_REGION}/api/config/enabled_features/${feature}`, enabled);
  await invalidateQueries([q.whoAmIOnAccount.filter(), q.accounts.filter()]);
  return res;
}

export async function updatePromptModifiers(preferences: PromptModifiers) {
  const res = await jsonApi.post<"ok">(`/region/${CURRENT_REGION}/api/config/prompt_modifiers`, preferences);
  await invalidateQueries([q.whoAmIOnAccount.filter(), q.accounts.filter()]);
  return res;
}

export async function updateAiModelConfig(config: AiModelConfig) {
  const res = await jsonApi.post<"ok">(`/region/${CURRENT_REGION}/api/config/ai_model_config`, config);
  await invalidateQueries([q.whoAmIOnAccount.filter(), q.accounts.filter()]);
  return res;
}
